import {PopupDialogbox} from 'client/CommonComponents'

interface IProps {
    Popupcontent?:any,
    hideDialog?:any,
    popupOutlinebtnOnclick?:any,
    popupPrimarybtnOnclick?:any,
    onDismiss?:any
}
const CompleteConfirmationPopup = ({popupPrimarybtnOnclick,Popupcontent,hideDialog,popupOutlinebtnOnclick, onDismiss}:IProps) => {
    return (
        <PopupDialogbox  hideDialog={!Popupcontent.isDialogVisible} onDismiss={onDismiss} Popupcontent={Popupcontent} popupOutlinebtnOnclick={popupOutlinebtnOnclick} popupPrimarybtnOnclick={()=>popupPrimarybtnOnclick('Home')}  data-attribute="CompleteConfirmationPopup_Default_PopupDilalogBox" />
    )
}

export default CompleteConfirmationPopup;